import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const i = a((r, s) => /* @__PURE__ */ o.jsx(
  e,
  {
    ref: s,
    ...r,
    image: (t) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M4 14h9a3 3 0 0 0 .982-5.836C13.46 7.984 13 7.552 13 7a5 5 0 0 0-9.762-1.53c-.121.38-.414.685-.782.839A4.001 4.001 0 0 0 4 14"
          }
        )
      }
    )
  }
));
i.displayName = "CloudIcon";
export {
  i as CloudIcon,
  i as default
};
//# sourceMappingURL=index.js.map
